export default __webpack_public_path__ + "static/media/Pilgrim's Armbands of the Bloody Stone.0212f347.jpg";